import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Header } from "@/components/Header";
import { PublicFooter } from "@/components/PublicFooter";
import { SEO, SITE_URL } from "@/components/SEO";
import { SOLUTIONS } from "@/lib/solutions";

export default function Solutions() {
  const canonical = `${SITE_URL}/solutions`;
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: SOLUTIONS.map((s, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: s.keyword,
      url: `${SITE_URL}/solutions/${s.slug}`,
    })),
  };

  return (
    <div className="min-h-screen" data-testid="solutions-hub">
      <SEO
        title="AI Visualization Software Solutions | Customize Studio"
        description="Explore Customize Studio solutions: AI visualization, before-and-after imaging, home improvement rendering, kitchen reface visualizing, and remodel preview software for sales teams."
        canonical={canonical}
        jsonLd={jsonLd}
      />
      <Header />
      <section className="mx-auto max-w-5xl px-6 py-16 md:px-10 lg:py-24">
        <p className="overline">Solutions</p>
        <h1 className="mt-3 font-display text-[2rem] font-semibold leading-[1.1] tracking-tight sm:text-5xl">
          One AI engine, every home improvement use case
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-[var(--ink-soft)]">
          Customize Studio renders photorealistic finished-project previews from a single photo. Explore how teams use it.
        </p>
        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {SOLUTIONS.map((s) => (
            <Link key={s.slug} to={`/solutions/${s.slug}`} data-testid={`solution-card-${s.slug}`}
              className="group rounded-2xl border border-[var(--line)] bg-white p-7 transition-all duration-200 hover:-translate-y-0.5 hover:border-[var(--brand)] hover:shadow-sm">
              <p className="overline text-[var(--brand)]">{s.keyword}</p>
              <p className="mt-2 font-display text-xl tracking-tight">{s.hero}</p>
              <p className="mt-2 text-sm text-[var(--ink-soft)]">{s.metaDescription}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--brand)]">
                Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
              </span>
            </Link>
          ))}
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
